import { InputNumber as InputNumberComponent } from 'kenshin';

const InputNumber = ({ ...rest }) => {
  return <InputNumberComponent stepType="inside" {...rest} />;
};

export default InputNumber;
